module.exports = __webpack_public_path__ + "media/recipes/45-2bc1c389.png";